'use client';

import { Box, Container, Typography } from '@mui/material';
import FadeIn from './FadeIn';
import { useRouter } from 'next/navigation';
import AnimatedGradientText from './AnimatedGradientText';
import ShimmerButton from './ShimmerButton';
import Image from 'next/image';

export default function HeroSection() {
  const router = useRouter();
  return (
    <FadeIn>
      <Box
        sx={{
          py: 4,
          bgcolor: 'rgba(0,0,0,0.6)',
          color: '#fff',
          textAlign: 'center',
        }}
      >
        <Container maxWidth="md">
        <Image
            src="/assets/images/AutomateAnalyzeInnovate.png"
            alt="Automate Analyze Innovate logo"
            width={200}
            height={200}
            priority
            style={{ margin: '0 auto', marginBottom: '1rem' }}
          />
          <AnimatedGradientText variant="h1" fontWeight="bold" gutterBottom>
            Automation Tools to Work Smarter & Scale Faster
          </AnimatedGradientText>
          <Typography variant="h6" component="p" sx={{ mb: 4 }}>
            We build automation tools, custom bots, and scrapers that eliminate manual work and unlock scalable growth.
          </Typography>
          <Typography variant="body1" sx={{ mb: 4 }}>
            Our team specializes in workflow automation and lead generation solutions built to save you hours and help your business scale.
          </Typography>
          <Box sx={{ display: 'flex', justifyContent: 'center', gap: 2 }}>
            <ShimmerButton variant="contained" size="large" onClick={() => router.push('/contact')}>
              Let's Talk About Your Next Project
            </ShimmerButton>
          </Box>
        </Container>
      </Box>
    </FadeIn>
  );
}
